import React, { forwardRef, useContext } from 'react'

import { ctaClick } from '@cred/react-analytics/events'
import Analytics from '@cred/react-analytics'
import { SnowplowReactContext } from '@cred/react-analytics/SnowplowContextManager'

import { analyticsProps } from './analyticsProps'

const extractChildrenText = children => {
  if (typeof children === 'string') {
    return children
  }
  if (Array.isArray(children)) {
    return children.join(' ')
  }

  return ''
}

const withAnalytics = (Button, defaultConfig = { disabled: false }) => {
  const ComponentWithAnalytics = forwardRef(
    (
      {
        onClick,
        analytics,
        disabled,
        showDisabled,
        href,
        children,
        analyticsContexts: buttonAnalyticsContexts = [],
        ...props
      },
      ref,
    ) => {
      const analyticsContexts = [...useContext(SnowplowReactContext), ...buttonAnalyticsContexts]
      let analyticsEventHandler

      if (analytics && !analytics.disabled) {
        analyticsEventHandler = (evt, ...args) => {
          const overrideData = analytics.data || {}

          if (onClick) {
            onClick(evt, ...args)
          }

          if (!evt.defaultPrevented) {
            evt.persist()
            setTimeout(() => {
              const analyticsObj = new Analytics(ctaClick.analytics(null, analyticsContexts))
              const elementPosition = overrideData?.elementPosition
              const elementName = overrideData?.elementName

              analyticsObj.event({
                href: overrideData.href || href,
                activated:
                  overrideData.activated !== undefined
                    ? overrideData.activated
                    : !disabled && !showDisabled,
                text: overrideData.text || extractChildrenText(children),
                elementPosition,
                elementName,
              })
            }, 0)
          }
        }
      }

      return (
        <Button
          onClick={analyticsEventHandler}
          disabled={disabled}
          showDisabled={showDisabled}
          href={href}
          {...props}
          ref={ref}
        >
          {children}
        </Button>
      )
    },
  )

  ComponentWithAnalytics.propTypes = {
    ...Button.propTypes,
    ...analyticsProps,
  }

  ComponentWithAnalytics.defaultProps = {
    ...Button.defaultProps,
    analytics: defaultConfig,
    analyticsContexts: [],
  }

  return ComponentWithAnalytics
}

export default withAnalytics
